module.exports = __webpack_public_path__ + "img/speaker-ShotaArveladze-imgs.860f2258.png";